import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSendTransfers } from './_requests/sendTransfers'
import BulkForm from '../../../packages/kiti/components/form/form/BulkForm'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import StockItemSelect from '../../../containers/stocks/select/StockItemSelect'
import OperationType from '../../../containers/stocks/select/OperationType'
import StockTransactionStatusTag from '../../../containers/stocks/StockTransactionStatusTag'
import { default as XNumberInput } from '../../../packages/kiti/components/form/NumberInput'
import { genClientCode } from '../_helper/helper'
import UserSelect from '../../../containers/users/select/UserSelect'
import ExecButton from './ExecButton'
import PlaceSelect from '../../../containers/places/select/PlaceSelect'

const TransfersForm = ({ isEditing }) => {
  const { t } = useTranslation('editStocks')
  const disableUserSelection = item => {
    return (
      item.status === 'success' ||
      !item.item ||
      !item.operationType ||
      item.operationType?.id === 'add_to_general' ||
      item.operationType?.id === 'remove_general_stock' ||
      item.operationType?.id === 'transfer_from_general_to_place' ||
      item.operationType?.id === 'transfer_from_place_to_general' ||
      item.operationType?.id === 'set_general_stock'
    )
  }

  const disablePlaceSelection = item => {
    return (
      item.status === 'success' ||
      !item.item ||
      !item.operationType ||
      item.operationType?.id === 'add_to_general' ||
      item.operationType?.id === 'remove_general_stock' ||
      item.operationType?.id === 'transfer_from_general_to_user' ||
      item.operationType?.id === 'transfer_from_user_to_general' ||
      item.operationType?.id === 'set_general_stock'
    )
  }

  return (
    <Scroll height="69vh" scroll scrollX direction="row">
      <Separator weight={8} flex={1}>
        <BulkForm
          hideDuplicateButton
          isEditing={isEditing}
          disableMultiEdit
          initialItemState={() => ({ status: 'pending', clientCode: genClientCode() })}
          fields={[
            {
              label: t('bulkTransfer.fields.status'),
              name: 'status',
              disabled: true,
              Input: StockTransactionStatusTag,
              width: '55px'
            },
            {
              label: t('bulkTransfer.fields.item'),
              name: 'item',
              Input: StockItemSelect,
              width: 20,
              dynamicProps: item => ({ disabled: item.status === 'success' })
            },
            {
              label: t('bulkTransfer.fields.operation'),
              name: 'operationType',
              Input: OperationType,
              width: 20,
              dynamicProps: item => ({
                disabled: item.status === 'success' || !item.item
              })
            },
            {
              label: t('bulkTransfer.fields.user'),
              name: 'user',
              Input: UserSelect,
              width: 18,
              dynamicProps: item => ({
                disabled: disableUserSelection(item),
                value: item.operationType?.id === 'add_to_general' ? null : item.user
              })
            },
            {
              label: t('bulkTransfer.fields.place'),
              name: 'place',
              Input: PlaceSelect,
              width: 18,
              dynamicProps: item => ({
                disabled: disablePlaceSelection(item),
                value: item.operationType?.id === 'add_to_general' ? null : item.place
              })
            },
            {
              label: t('bulkTransfer.fields.amount'),
              name: 'amount',
              Input: XNumberInput,
              width: 5,
              dynamicProps: item => ({ disabled: item.status === 'success' || !item.item })
            }
          ]}
        />
      </Separator>
    </Scroll>
  )
}

const Wrapper = () => {
  const [onSubmit, { loading, error }] = useSendTransfers()

  return (
    <Form
      onSubmit={!loading ? onSubmit : undefined}
      initialState={[{ status: 'pending', clientCode: genClientCode() }]}
    >
      <TransfersForm />
      <Line />
      <ExecButton loading={loading} error={error} />
    </Form>
  )
}

export default Wrapper
